
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getSendEmailToAgentsDtoFormGroup() {
return new FormGroup({
    timerecorddetailIds: new FormControl<Array<number> | undefined>([], [Validators.required]),
})
;
}
      